var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"container"}},[(_vm.waiting)?_c('i',{staticClass:"fa fa-spinner spin fa-2x text-white"}):_vm._e(),(!_vm.waiting)?_c('iframe',{attrs:{"src":_vm.src}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }